// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "headingWrp-2S4wz";
var _4 = "fareHeadingItem-1orf9";
var _5 = "fareHeadingItem__title-3O4Jn";
var _6 = "fareHeadingItem__serviceClass-1jXNN";
var _7 = "fareHeadingItem__fareTitle-2iu-K";
var _8 = "fareHeadingItem_isKey-2zRkn";
var _9 = "fareHeadingItem_isFirstClass-3EpW8";
var _a = "image-2IvPD";
var _b = "selectedFare-2wk4s";
export { _1 as "__esModule", _2 as "tablet", _3 as "headingWrp", _4 as "fareHeadingItem", _5 as "fareHeadingItem__title", _6 as "fareHeadingItem__serviceClass", _7 as "fareHeadingItem__fareTitle", _8 as "fareHeadingItem_isKey", _9 as "fareHeadingItem_isFirstClass", _a as "image", _b as "selectedFare" }
export default { "__esModule": _1, "tablet": _2, "headingWrp": _3, "fareHeadingItem": _4, "fareHeadingItem__title": _5, "fareHeadingItem__serviceClass": _6, "fareHeadingItem__fareTitle": _7, "fareHeadingItem_isKey": _8, "fareHeadingItem_isFirstClass": _9, "image": _a, "selectedFare": _b }
